<mat-chip-listbox>
    <mat-chip-option disableRipple matTooltip="{{tooltipDescription}}" class="sf-plan-flag" (click)="showUpgradeDialogToTrial($event)" [ngClass]="inUpgradeDialog ? 'not-clickable' : ''">
        {{ plan }}
    </mat-chip-option>
</mat-chip-listbox>
